module.exports = __webpack_public_path__ + "static/media/20_000006.dd968bce.jpg";